import React from 'react';

import { HFS_WEBSITE } from 'components/prequalification/EntryFormResult/entryFormResult.constants';
import styles from 'components/prequalification/EntryFormResult/EntryFormResult.module.scss';

interface TeamMembersProps {
  name?: string;
  position?: string;
  phone?: string;
  email?: string;
  isDefault?: boolean;
}

const TeamMembers = (teamMembersProps: TeamMembersProps) => {
  const mailLink = `mailto:${teamMembersProps.email}`;

  return (
    <div className={styles.teamMemberBlock}>
      <div className={styles.textBlock}>
        <p className={styles.boldText}>{teamMembersProps.name}</p>
        <p className={styles.greyText}>{teamMembersProps.position}</p>
        {!teamMembersProps.isDefault && <p className={styles.greyText}>HFS financial</p>}
      </div>
      <div className={styles.textBlock}>
        <p className={styles.boldText}>{teamMembersProps.phone}</p>
        <a className={styles.link} href={mailLink}>
          {teamMembersProps.email}
        </a>
        <a className={styles.link} href={HFS_WEBSITE}>
          www.hfsfin.com
        </a>
      </div>
    </div>
  );
};

export default TeamMembers;
